var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { getUserFromLocalStorage } from "./localStorage";
export const getOrders = (
// userId?: string,
currentPage, pageSize) => __awaiter(void 0, void 0, void 0, function* () {
    const user = getUserFromLocalStorage();
    // const role = user.role;
    // const userId = user.account_id;
    const authToken = user.access_token;
    const whereObj = encodeURI(JSON.stringify({
        viewer: process.env.REACT_APP_VIEWER_ID,
        // created_by: userId,
    }));
    return yield axios
        .get(process.env.REACT_APP_HELLOAR_API + "viewer_orders?where=" + whereObj, {
        params: {
            max_results: pageSize,
            page: currentPage,
            sort: "-created_at",
        },
        headers: {
            Authorization: `Token ${authToken}`,
        },
    })
        .then((res) => {
        return { _items: res.data._items, totalOrders: res.data._meta.total };
    });
});
//patch order
export const patchOrder = (_order) => __awaiter(void 0, void 0, void 0, function* () {
    const order = Object.assign({}, _order);
    delete order.created_at;
    delete order.updated_at;
    const user = yield getUserFromLocalStorage();
    return yield axios
        .patch(process.env.REACT_APP_HELLOAR_API + `viewer_orders/${order._id}`, order, {
        headers: {
            "Content-Type": "application/json;charset=utf-8",
            Authorization: `Token ${user.access_token}`,
        },
    })
        .then((res) => {
        return res.data;
    })
        .catch((err) => {
        throw new Error("error creating order:" + err.message);
    });
});
//delete order
export const deleteOrder = (orderId) => __awaiter(void 0, void 0, void 0, function* () {
    const user = getUserFromLocalStorage();
    return yield axios
        .delete(process.env.REACT_APP_HELLOAR_API + "viewer_orders/" + orderId, {
        headers: {
            "Content-Type": "application/json;charset=utf-8",
            Authorization: `Token ${user.access_token}`,
        },
    })
        .then((res) => {
        return res.data;
    })
        .catch((err) => {
        throw new Error("error deleting order:" + err.message);
    });
});
//create order
export const createOrder = (order) => __awaiter(void 0, void 0, void 0, function* () {
    const user = getUserFromLocalStorage();
    return yield axios
        .post(process.env.REACT_APP_HELLOAR_API + "viewer_orders", order, {
        headers: {
            "Content-Type": "application/json;charset=utf-8",
            Authorization: `Token ${user.access_token}`,
        },
    })
        .then((res) => {
        return res.data;
    })
        .catch((err) => {
        throw new Error("error creating order:" + err.message);
    });
});
//search orders
export const searchOrders = (searchTerm, currentPage, pageSize) => __awaiter(void 0, void 0, void 0, function* () {
    const user = getUserFromLocalStorage();
    const authToken = user.access_token;
    const whereObj = encodeURI(JSON.stringify(Object.assign(Object.assign({}, (searchTerm && {
        $or: [
            { "customer.name": { $regex: searchTerm, $options: "i" } },
            { "customer.email": { $regex: searchTerm, $options: "i" } },
            { "customer.phone_number": { $regex: searchTerm, $options: "i" } },
            { "customer.location": { $regex: searchTerm, $options: "i" } },
            { lead_id: { $regex: searchTerm, $options: "i" } },
        ],
    })), { viewer: process.env.REACT_APP_VIEWER_ID })));
    return yield axios
        .get(process.env.REACT_APP_HELLOAR_API + "viewer_orders?where=" + whereObj, {
        params: {
            max_results: pageSize,
            page: currentPage,
            sort: "-created_at",
        },
        headers: {
            Authorization: `Token ${authToken}`,
        },
    })
        .then((res) => {
        return { _items: res.data._items, totalOrders: res.data._meta.total };
    });
});
